import PreClaimsTypes from './PreClaimsTypes';

export const createPreClaimsInProgress = (payload) => ({
  type: PreClaimsTypes.CREATE_CLAIM_PROGRESS,
  payload,
});

export const getPreClaimsDuplicatesInProgress = (payload) => ({
  type: PreClaimsTypes.GET_CLAIM_DUPLICATES_PROGRESS,
  payload,
});
export const getPreClaimsDuplicatesInSuccess = (payload) => ({
  type: PreClaimsTypes.GET_CLAIM_DUPLICATES_SUCCESS,
  payload,
});
export const getPreClaimsDuplicatesInError = (payload) => ({
  type: PreClaimsTypes.GET_CLAIM_DUPLICATES_ERROR,
  payload,
});
